import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { SeasonRateDetails } from '../../features/seasonRates/seasonRatesSlice';

export function fetchSeasonRatesByAccommodationId(
  accommodationId: string,
  startFetchingRatesFrom?: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId, startFetchingRatesFrom },
  };

  return axios
    .get('/pricing/rates/GetSeasonRatesByAccommodationId', config)
    .then(res => res.data);
}

export function fetchSeasonRateDetails(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .get('/pricing/rates/getSeasonRateDetails', config)
    .then(res => res.data);
}

export function addSeasonRate(seasonRateData: SeasonRateDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .post('/pricing/rates/addSeasonRate', seasonRateData, config)
    .then(res => res.data);
}

export function updateSeasonRate(seasonRateData: SeasonRateDetails) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .put('/pricing/rates/updateSeasonRate', seasonRateData, config)
    .then(res => res.data);
}

export function deleteSeasonRate(seasonRateId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { seasonRateId },
  };

  return axios
    .delete('/pricing/rates/deleteSeasonRate', config)
    .then(res => res.data);
}

export function deleteSeasonRatesByAccommodationId(accommodationId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId },
  };

  return axios
    .delete('/pricing/rates/deleteSeasonRatesByAccommodationId', config)
    .then(res => res.data);
}
